import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../Components/Firebase/firebaseConfig"; // Ensure the correct relative path
import"./Contact.css"
const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "contacts"), {
        name,
        email,
        message,
        timestamp: serverTimestamp(),
      });
      alert("Message has been submitted");
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <section>
      <div className="container">
        <h2> تواصل معنا</h2>
        <form onSubmit={handleSubmit} className="w-75 m-auto">
          <div className="form-group">
            <label htmlFor="name">الاسم :</label>
            <input
              type="text"
              className="form-control"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">الايميل :</label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">الرسالة :</label>
            <textarea
              className="form-control"
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary my-3">
            ارسال
          </button>
        </form>
      </div>
      <div class="container mt-5">
        <div class="row">
          <div class="col-md-4">
            <div class="card text-center">
              <div class="card-body">
                <i class="fas fa-phone fa-3x mb-3"></i>
                <h5 class="card-title">Call Us</h5>
                <p class="card-text">+123 456 7890</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card text-center">
              <div class="card-body">
                <i class="fas fa-envelope fa-3x mb-3"></i>
                <h5 class="card-title">Email Us</h5>
                <p class="card-text">info@example.com</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card text-center">
              <div class="card-body">
                <i class="fas fa-map-marker-alt fa-3x mb-3"></i>
                <h5 class="card-title">Visit Us</h5>
                <p class="card-text">123 Example St, City</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
